import {FC, useState, useEffect} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import {WithChildren} from '../../../../_metronic/helpers'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {logout} from './_requests'
import {StoreModel} from '../../../redux/types'

const AuthInit: FC<WithChildren> = ({children}) => {
  const [showSplashScreen, setShowSplashScreen] = useState(false)
  const dispatch = useDispatch()
  const {auth} = useSelector(
    (state: StoreModel) => ({
      auth: state.globalStates.auth,
    }),
    shallowEqual
  )

  useEffect(() => {
    if (auth && auth.api_token) {
    } else {
      logout(dispatch)
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthInit}
